import { GlobalService } from 'src/app/global.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from '../../http.service';
import { ProductUnitService } from '../product-unit.service';

@Component({
  selector: 'app-product-unit-table',
  templateUrl: './product-unit-table.component.html',
  styleUrls: ['./product-unit-table.component.scss']
})
export class ProductUnitTableComponent implements OnInit {
  displayedColumns: string[] = ['id', 'name', 'display_name'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private http: HttpService, public productUnitService: ProductUnitService, private global: GlobalService) {
    this.getProductUnits();
    this.productUnitService.downloadProductUnit.subscribe((is_update_zone) => {
      console.log(is_update_zone);
      if (is_update_zone) {
        this.getProductUnits();
      }
    });
    this.global.set_master_page_title = 'Product Unit';
  }

  showProductUnitRegister() {
    this.productUnitService.is_display_product_unit_register_component = true;
  }

  hideProductUnitRegister() {
    this.productUnitService.is_display_product_unit_register_component = false;
  }

  registerProductUnitGroup() {
    this.showProductUnitRegister();
    console.log('register zone');
    this.productUnitService.productUnitUpdate.emit(null);
    this.productUnitService.set_product_unit_data = null;
  }


  editProductUnit(product_group) {
    this.showProductUnitRegister();
    console.log(product_group);
    this.productUnitService.productUnitUpdate.emit(product_group);
    this.productUnitService.set_product_unit_data = product_group;
  }

  getProductUnits() {
    this.http.getProductUnit().subscribe((data: ProductUnit[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<ProductUnit>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {
  }

}

export interface ProductUnit {
  id: number;
  name: string;
  display_name: string;
}
